// Per-project Google Meet account: status, start connect (returns OAuth URL we
// open in a popup), disconnect. Listening for the popup's postMessage is the
// caller's job — see MeetConnectPanel.

import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { crmApi } from "../api/client";

const key = (projectId) => ["crm", "project-meet-account", projectId];

export function useProjectMeetAccount(projectId) {
  return useQuery({
    queryKey: key(projectId),
    enabled: !!projectId,
    queryFn: async () => {
      const { data } = await crmApi.get(`/projects/${projectId}/meet-account`);
      return data;
    },
    staleTime: 30_000,
  });
}

export function useStartMeetConnect() {
  return useMutation({
    mutationFn: async (projectId) => {
      const { data } = await crmApi.get(`/auth/google/connect-meet/start`, { params: { projectId } });
      return data;
    },
  });
}

export function useDisconnectMeetAccount(projectId) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async () => (await crmApi.delete(`/projects/${projectId}/meet-account`)).data,
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: key(projectId) });
      // Disconnecting the Meet account leaves the per-lead meetings hanging
      // (sync stops working, summary pipeline can't re-fetch artifacts) —
      // refresh meeting lists for any lead in this project so the UI shows
      // current state. We fan out broadly since meetings are keyed by leadId,
      // not projectId, in the query cache.
      qc.invalidateQueries({ queryKey: ["crm", "lead-meetings"] });
      qc.invalidateQueries({ queryKey: ["crm", "dashboard", "overview"] });
    },
  });
}
